import { useGetListWallet } from '../../api/wallet';

export const useWalletManagement = (
  companyId: number,
  params: { start: number; end: number },
  searchName: string,
  enabled = true
) => {
  const {
    data = {
      data: {
        data: {
          items: [],
          total: 0,
          page: 1,
          pageSize: 20,
          totalPages: 0,
        },
      },
    },
    isLoading,
    refetch,
  } = useGetListWallet({
    companyId,
    ...params,
    name: searchName,
    enabled,
  });

  const dataListWallet = {
    items: data?.data?.data?.items || [],
    total: data?.data?.data?.total || 0,
    page: data?.data?.data?.page || 1,
    pageSize: data?.data?.data?.pageSize || 20,
    totalPages: data?.data?.data?.totalPages || 0,
  };

  return { dataListWallet, refetch, isLoading };
};

